/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { miscGetMiscTimestamp } from "../../funcs/miscGetMiscTimestamp.js";
import { GetMiscTimestampRequest$zodSchema } from "../../models/getmisctimestampop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetMiscTimestampRequest$zodSchema,
};

export const tool$miscGetMiscTimestamp: ToolDefinition<typeof args> = {
  name: "misc-get-misc-timestamp",
  description: `转换时间戳 (旧版，推荐使用/convert/unixtime)

这是一个用于将Unix时间戳转换为人类可读日期时间的旧版接口。

## 功能概述
输入一个秒级或毫秒级的时间戳，返回其对应的本地时间和UTC时间。

> [!WARNING]
> **接口已过时**：这个接口已被新的 \`/convert/unixtime\` 取代。新接口功能更强大，支持双向转换。我们建议你迁移到新接口。

[➡️ 前往新版接口文档](/docs/api-reference/get-convert-unixtime)`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await miscGetMiscTimestamp(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
